import { apiHelper } from '@/utils';
import { API } from '@/constants';

const API_URL = `${API.BASE_URL_API}/v1`;

export const notificationIconService = {
    getAll, store, show, update, updateStatus, softDelete, forceDelete,
};

export function getAll(filter = {}) {
    const params = {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_active: filter.isActive === '' ? undefined : filter.isActive,
        sortBy: filter.sortBy,
        orderBy: filter.orderBy,
    };
    const searchWords = (filter.searchArray || []).filter((word) => word != null && word !== '');
    if (searchWords.length) {
        params.search_words = searchWords;
    }
    return apiHelper(API_URL).get('/notification-icons', { params });
}

function toFormData(data, method = null) {
    const formData = new FormData();
    formData.append('name', data.name);
    formData.append('is_active', data.isActive ? 1 : 0);
    if (data.file instanceof File) formData.append('file', data.file);
    if (method) formData.append('_method', method);
    return formData;
}

export function store(data) {
    return apiHelper(API_URL).post('/notification-icons', toFormData(data));
}

export function show(uuid) {
    return apiHelper(API_URL).get(`/notification-icons/${uuid}`);
}

export function update(data) {
    return apiHelper(API_URL).post(`/notification-icons/${data.uuid}`, toFormData(data, 'PUT'));
}

export function updateStatus(uuid, isActive) {
    return apiHelper(API_URL).patch(`/notification-icons/${uuid}`, { is_active: isActive ? 1 : 0 });
}

export function softDelete(uuid) {
    return apiHelper(API_URL).patch(`/notification-icons/delete/${uuid}`);
}

export function forceDelete(uuid) {
    return apiHelper(API_URL).delete(`/notification-icons/forceDelete/${uuid}`);
}
